import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';

function TwitterColourSmall(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fill: "#1DA1F2",
    fillRule: "evenodd",
    d: "M6.29 17.5c7.547 0 11.675-5.771 11.675-10.776 0-.164 0-.328-.012-.49A8.026 8.026 0 0020 4.274a8.731 8.731 0 01-2.357.595c.857-.473 1.498-1.217 1.804-2.094a8.651 8.651 0 01-2.605.919c-1.554-1.525-4.154-1.599-5.806-.165-1.066.925-1.518 2.304-1.187 3.62-3.3-.154-6.373-1.592-8.457-3.958-1.09 1.73-.533 3.944 1.27 5.056A4.335 4.335 0 01.8 7.773v.048c0 1.803 1.377 3.356 3.292 3.713a4.427 4.427 0 01-1.853.065c.538 1.542 2.078 2.6 3.834 2.63-1.453 1.054-3.248 1.626-5.096 1.624-.327 0-.653-.018-.977-.054a12.333 12.333 0 006.29 1.698",
    clipRule: "evenodd"
  }));
}

export default TwitterColourSmall;
//# sourceMappingURL=TwitterColourSmall.js.map